import Gateway from '@/utils/Gateway';

function transTreeData(data, custTransItem) {
    const { deps, users } = data || {};
    const list = [];

    if (users && users.length) {
        users.forEach(uItem => {
            let transItem = { ...uItem };

            transItem.id = uItem.userid;
            transItem.isParent = 0;

            if (typeof custTransItem === 'function') {
                transItem = custTransItem(transItem);
            }

            list.push(transItem);
        });
    }

    if (deps && deps.length) {
        deps.forEach(dItem => {
            let transItem = { ...dItem };

            transItem.isParent = 1;

            if (typeof custTransItem === 'function') {
                transItem = custTransItem(transItem);
            }

            list.push(transItem);
        });
    }

    return list;
}

export default function(params, transItem) {
    const { depId, index, count } = params;

    return Gateway.get(
        '/v1/wework/DepTreeNode',
        {
            depId,
            index,
            count
        },
        { originRes: true }
    )
        .then(res => {
            const { code, message, data } = res || {};
            const { index: resIndex, count: resCount, total_node: resTotal } = data || {};

            if (code === 0) {
                return {
                    data: {
                        list: transTreeData(data, transItem),
                        index: resIndex,
                        count: resCount,
                        total_node: resTotal
                    }
                };
            }

            Vue.prototype.$message.error(message || '获取数据失败');

            return {
                list: []
            };
        })
        .catch(err => {
            const { message } = err || {};
            Vue.prototype.$message.error(message || '获取数据失败');
        });
}
